import * as React from "react";
import { useState } from "react";
import {
  normalizeUserContextData,
  RailsUserContext,
} from "../../libs/user_context";
import PageContainer from "../core/PageContainer";
import { HashRouter as Router, Route } from "react-router-dom";
import CommissionConfigsContainer from "../commission_calculator/CommissionConfigsContainer";
import { wrapComponentForErrors } from "../utility/ErrorHandler";
import CommissionTester from "../commission_calculator/CommissionTester";
import CommissionCalculatorIndex from "../commission_calculator/CommissionCalculatorIndex";
import CommissionUserContainer from "../commission_calculator/CommissionUserContainer";
import CommissionEmployeeIndex from "../commission_calculator/CommissionEmployeeIndex";
import CommissionMonthContainer from "../commission_calculator/CommissionMonthContainer";
import CommissionCalculatorAdmin from "../commission_calculator/CommissionCalculatorAdmin";

function CommissionCalculator({ userContext: rawUserContext }) {
  const [userContext] = useState(normalizeUserContextData(rawUserContext));
  const { user, org } = userContext;
  const canAdmin = user.isAdmin;
  const canManage =
    canAdmin || user.isOwner || user.roles.includes("sales_manager");

  // this is lifted up here so it doesn't change on us when the top-level admin component is remounted by react-router
  const adminOrgState = useState(userContext.user.organization.id);

  return (
    <RailsUserContext.Provider value={userContext}>
      <PageContainer>
        <Router hashType="noslash">
          <>
            <Route
              path={"/"}
              exact
              render={props =>
                canManage ? (
                  <CommissionCalculatorIndex {...props} org={org} />
                ) : (
                  <CommissionEmployeeIndex user={user} org={org} />
                )
              }
            />
            <Route
              path={"/tester"}
              render={props => <CommissionTester {...props} user={user} />}
            />
            {canManage && (
              <>
                <Route
                  path={"/configs"}
                  render={props => (
                    <CommissionConfigsContainer {...props} org={org} />
                  )}
                />
                <Route
                  path={"/salespeople/:user"}
                  render={props => (
                    <CommissionUserContainer
                      {...props}
                      commissionUserId={props.match.params.user}
                    />
                  )}
                />
              </>
            )}
            <Route
              path={"/commissions/:monthId"}
              render={props => (
                <CommissionMonthContainer
                  {...props}
                  commissionMonthId={props.match.params.monthId}
                />
              )}
            />
            {canAdmin && (
              <Route
                path={"/admin"}
                render={() => (
                  <CommissionCalculatorAdmin adminOrgState={adminOrgState} />
                )}
              />
            )}
          </>
        </Router>
      </PageContainer>
    </RailsUserContext.Provider>
  );
}

export default wrapComponentForErrors(CommissionCalculator);



// WEBPACK FOOTER //
// ./app/javascript/components/pages/CommissionCalculator.tsx